import React, { useEffect } from 'react'
import { termsActions } from '../../store/actions'
import { connect } from 'react-redux'

// import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer'
// import '@toast-ui/editor/dist/toastui-editor-viewer.css'

const PolicyTerms = (props) => {
  const viewer = document.querySelector('#viewer')

  useEffect(() => {
    props.load()
  }, [])

  let trmsCn = decodeHTMLEntities(props?.terms?.data?.trmsCn?.replaceAll('& ', '&'))

  if (viewer != null && viewer != undefined) {
    viewer.innerHTML = trmsCn
  }

  /*   
    viewer &&
      new Viewer({
        el: document.querySelector('#viewer'),
        viewer: true,
        initialValue: trmsCn,
      })
  */
  return (
    <React.Fragment>
      <div id="viewer"></div>
    </React.Fragment>
  )
}

function decodeHTMLEntities(str) {
  let element = document.createElement('div')
  if (str && typeof str === 'string') {
    // strip script/html tags
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
    element.innerHTML = str
    str = element.textContent
    element.textContent = ''
  }

  return str
}

const mapStateToProps = (state) => {
  return { terms: state.terms }
}

const actionCreators = {
  load: termsActions.load,
}

export default connect(mapStateToProps, actionCreators)(PolicyTerms)
